import styled from 'styled-components';
import { layout, LayoutProps, variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { getBoxShadow } from './utils/getBoxShadow';
import { boxShadow } from './system';
import { BorderVariant, Variant } from './types';

export const BoxShadow = styled.div<
  {
    borderVariant: BorderVariant;
    boxShadow: ReturnType<typeof getBoxShadow>;
  } & LayoutProps
>`
  position: absolute;
  width: 100%;
  z-index: 1;
  pointer-events: none;
  ${boxShadow};
  ${layout};
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Options', 'borderVariant')
    )};
`;

export const SelectOptions = styled.div<
  {
    selectVariant: Variant;
    borderVariant: BorderVariant;
  } & LayoutProps
>`
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  border: 1px solid currentColor;
  z-index: 1;

  ${layout};
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Options', 'selectVariant')
    )};
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Options', 'borderVariant')
    )};
`;
